<label class="container" [class.container-disabled]="readonly">
  <input
    type="checkbox"
    [class.checkbox-disabled]="readonly"
    [disabled]="readonly"
    [checked]="value"
    (change)="onChange($event)"
  />
  <span class="checkmark"></span>
</label>
